import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import {
  baselineCategory,
  baselineQuestion,
  Product,
  userProductEntry,
  UserFlightEntry,
  userBaselineEntry,
  baselineConstant
} from 'src/app/shared/models/interfaces';

@Injectable({
  providedIn: 'root',
})
export class BaselineService {
  private baselineUrl = `${environment.api}/baseline`;
  private digitalProductsUrl = `${environment.api}/baseline/digitalization`;
  private baselineEntriesUrl = `${environment.api}/entries/userBaselineEntries`;
  private productEntriesUrl = `${environment.api}/entries/userProductEntries`;
  private flightEntriesUrl = `${environment.api}/entries/userFlightEntries`;

  constructor(private http: HttpClient) {}

  getAllBaselineQuestionData() {
    return this.http.get<baselineQuestion[]>(
      `${this.baselineUrl}/questions/all`
    );
  }

  getBaselineConstants() {
    return this.http.get<baselineConstant[]>(
      `${this.baselineUrl}/constants`
    );
  }

  getBaselineCategories() {
    return this.http.get<baselineCategory[]>(`${this.baselineUrl}/categories`);
  }

  getUserBaselineEntries() {
    return this.http.get<userBaselineEntry[]>(`${this.baselineEntriesUrl}`);
  }

  createUserBaselineEntry(baselineEntry: userBaselineEntry) {
    return this.http.post(this.baselineEntriesUrl, baselineEntry);
  }

  updateUserBaselineEntry(baselineEntry: userBaselineEntry) {
    return this.http.patch(`${this.baselineEntriesUrl}/${baselineEntry.id}`, baselineEntry);
  }

  getDigitalProductData() {
    return this.http.get<Product[]>(`${this.digitalProductsUrl}`);
  }

  getUserProductEntries() {
    return this.http.get<userProductEntry[]>(`${this.productEntriesUrl}`);
  }

  createUserProductEntry(productEntry: userProductEntry) {
    return this.http.post<userProductEntry>(
      this.productEntriesUrl,
      productEntry
    );
  }

  updateUserProductEntry(productEntry: userProductEntry) {
    return this.http.patch<userProductEntry>(`${this.productEntriesUrl}/${productEntry.id}`, productEntry);
  }

  deleteUserProductEntry(productEntryId: number) {
    return this.http.delete(`${this.productEntriesUrl}/${productEntryId}`);
  }

  getUserFlightEntries() {
    return this.http.get<UserFlightEntry[]>(`${this.flightEntriesUrl}`);
  }

  createUserFlightEntry(flightEntry: UserFlightEntry) {
    return this.http.post(this.flightEntriesUrl, flightEntry);
  }

  deleteUserFlightEntry(flight: UserFlightEntry) {
    return this.http.delete(`${this.flightEntriesUrl}/${flight.id}`);
  }

  createDidNotFlyEntry() {
    // This creates a flight entry with a didNotFly flag and no emissions
    // The already existing flight entries are deleted
    return this.http.post(`${environment.api}/flights/didNotFly`, null);
  }

  deleteDidNotFlyEntry() {
    return this.http.delete(`${environment.api}/flights/didNotFly`);
  }
}
